import React from "react";
import { IonItem, IonLabel, IonButton, IonIcon } from "@ionic/react";
import { closeCircle, refreshCircle } from "ionicons/icons";
import styles from "./PaymentCard.module.scss";
import { Card } from "@core/types";
import { useDeleteCardMutation } from "../../providers/cards";
import { queryClient } from "../../config/query-client";

interface PaymentCardProps {
  card: Card;
}

const PaymentCard: React.FC<PaymentCardProps> = ({ card }) => {
  const { mutateAsync, isLoading } = useDeleteCardMutation({
    onSuccess: ({ deletedId }) => {
      queryClient.setQueryData<Card[]>(["cards"], (oldData) => {
        const updatedData = oldData?.filter((card) => card.id != deletedId);
        console.log(updatedData, updatedData?.length);
        return updatedData;
      });
    },
  });

  return (
    <IonItem>
      <IonLabel>
        <h2>{card.cardType}</h2>
        <p>**** **** **** {card.cardLastFour}</p>
      </IonLabel>
      {/* <IonButton onClick={onPresentModal} fill="clear" disabled={isDeleting}>
        <IonIcon icon={createOutline} />
      </IonButton> */}
      <IonButton
        onClick={() => mutateAsync(card)}
        color={isLoading ? "medium" : "danger"}
        fill="clear"
        disabled={isLoading}
      >
        <IonIcon icon={isLoading ? refreshCircle : closeCircle} className={isLoading ? styles.spinIcon : ""} />
      </IonButton>
    </IonItem>
  );
};

export default PaymentCard;
